export default [
  {
    title: 'Name',
    type: 'text',
    required: true,
    dataIndex: 'name',
  }
]